import { FETCH_CART_REQUEST, FETCH_CART_SUCCESS, FETCH_CART_ERROR } from '../constants/ActionTypes'

const initialState = {
    isFetching: false,
    payload: null,
    error: null,
}

export default function cart(state = initialState, action) {
    switch (action.type) {
        case FETCH_CART_REQUEST:
            return {
                ...state,
                isFetching: true,
            }
        case FETCH_CART_SUCCESS:
            return {
                isFetching: false,
                payload: action.payload,
                error: null,
            }
        case FETCH_CART_ERROR:
            return {
                ...state,
                isFetching: false,
                error: action.error,
            }
        default:
            return state
    }
}
